/**
 * Analytics Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReportLoginViewModel { 
    timestamp?: string;
    userId?: number;
    userType?: string | null;
    username?: string | null;
    application?: string | null;
    authenticator?: string | null;
    isSuccess?: boolean;
}

